export const getChipLabelVisibilityFlags = <T>(
  orderedKeys: readonly T[],
  isConfigured: (key: T) => boolean
): boolean[] => {
  const chipVisibilityFlags = new Array<boolean>(orderedKeys.length).fill(false);

  let seenConfigured = false;

  for (let i = 0; i < orderedKeys.length - 1; i += 1) {
    if (isConfigured(orderedKeys[i])) {
      seenConfigured = true;
    }

    const nextIsConfigured = isConfigured(orderedKeys[i + 1]);
    chipVisibilityFlags[i] = seenConfigured && nextIsConfigured;
  }

  return chipVisibilityFlags;
};
